import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isRulesEnabled
      ? _c("div", [
          _vm.tabType === "rules"
            ? _c(
                "div",
                [
                  _c(
                    VContainer,
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { staticClass: "py-0 pr-0", attrs: { md: "6" } },
                            [
                              _c("architecture-drivers-ruleset", {
                                attrs: { disabled: false },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            VCol,
                            { attrs: { md: "6" } },
                            [
                              _c("architecture-drivers-overview", {
                                attrs: { disabled: false },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.tabType === "pricing"
            ? _c(
                "div",
                [
                  _c("line-pricing-editor", {
                    ref: "linePricingEditorComponent",
                    attrs: {
                      "scenario-key": _vm.scenario,
                      "architecture-group-id": _vm.architectureGroup,
                      editable: _vm.canEditRules,
                      disabled: false,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      : _c("div", { staticClass: "no-filters-message" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t(_vm.emptyStateTranslationKey)))]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }